/**
 * Vue i18n
 *
 * @library
 *
 * http://kazupon.github.io/vue-i18n/en/
 */

// Lib imports
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/lang';

Vue.use(VueI18n);
const localStorageLanguage = localStorage.getItem('language');

const url = new URL(window.location.href);
const queryLanguage = url.searchParams.get('lang');

const navigatorLanguage = (navigator.language.split('-')[0] || '').toLowerCase();

const defaultLanguage = 'de';

const lang = localStorageLanguage || queryLanguage || navigatorLanguage || defaultLanguage;

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'en',
  messages,
});

export default i18n;
